<template>


  <div id="property-management" class="flex flex-wrap-reverse items-center data-list-btn-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />


    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="restaurantlist">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ restaurantlist.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : restaurantlist.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="code">ID</vs-th>
        <vs-th sort-key="type">Name</vs-th>
        <vs-th sort-key="type">Lastname</vs-th>
        <vs-th sort-key="active">E-mail</vs-th>
        <vs-th sort-key="active">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.id }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.name | title }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.last_name | title }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.email | title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ getStatus(tr.active) | title }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

  </div>

</template>

<script>

import DataViewSidebar from './DataViewSidebar'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {

      addNewDataSidebar: false,
      sidebarData: {},
      selected: [],
      // products: [],
      itemsPerPage: 6,
      isMounted: false,
      user_group: 1
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.user_group !== ''
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist
    },
    properties () {
      return this.$store.state.api.properties
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.restaurantlist.length
    }
  },
  mounted () {
    this.user_group = 4
    this.propertyList(this.user_group)
    this.getUserList(this.user_group)
  },
  methods: {
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val

      if (val === false) {
        this.getUserList(this.user_group)
      }
    },
    getStatus (active) {
      if (active === 1) {
        return 'Active'
      } else {
        return 'Passive'
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.user_group = this.user_group
      this.sidebarData.propertyList = this.properties
      this.toggleDataSidebar(true)
    },
    editData (data) {
      this.sidebarData = data
      this.sidebarData.user_group = this.user_group
      this.sidebarData.propertyList = this.properties
      this.toggleDataSidebar(true)
    },
    propertyList (group_id) {
      // Loading
      this.$vs.loading()

      const payload = {
        user_group: group_id
      }

      this.$store.dispatch('api/getPropertyList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getUserList (group_id) {
      // Loading

      const payload = {
        user_group: group_id
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}

</script>

<style lang="scss">
  #property-management{
    .vs--single.vs--open .vs__selected{
      position: initial;
    }
    .vs-table-primary{
      width:100%;
    }
  }
</style>
